import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createGameRoundSlice, type GameRoundSlice } from '@/features/game-round';
import {
  createStandaloneHandoffSlice,
  type StandaloneHandoffSlice,
} from '@/features/standalone-handoff';

export type GameStoreState = GameRoundSlice & StandaloneHandoffSlice;

export const useGameStore = create<GameStoreState>()(
  subscribeWithSelector(
    immer((...a) => ({
      ...createGameRoundSlice(...a),
      ...createStandaloneHandoffSlice(...a),
    })),
  ),
);
